import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ICreatePlanPayload, IUpdatePlanPayload, planDurationList, planFields, ROUTES } from '@common/interfaces';
import { CommonHttpService } from 'libs/common/src/lib/service/common-http.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-subsciption-plan',
  templateUrl: './create-subsciption-plan.component.html',
  styleUrls: ['./create-subsciption-plan.component.scss']
})
export class CreateSubsciptionPlanComponent {
  loaderView: boolean = true;
  planDetails = new FormGroup({
    planName: new FormControl('', [Validators.required, Validators.pattern(/^(?!.*\s{2,})(?!^\s)(?!.*\s$)[A-Za-z0-9]+(?:\s[A-Za-z0-9]+)*$/)]),
    numWorkspaceOwners: new FormControl('', Validators.required),
    numEndUsers: new FormControl('', Validators.required),
    numItAdmins: new FormControl('', Validators.required),
    numOfAssets: new FormControl('', Validators.required),
    planFee: new FormControl('', Validators.required),
    planDuration: new FormControl('', Validators.required),
    currencyId: new FormControl('', Validators.required)
  });
  isEdit: boolean = false;
  currenciesList = [];
  planDurationList = planDurationList;
  planId: string | null = null;
  selectedValue: string = '';
  buttonText: string = "Save";
  constructor(
    private router: Router,
    private commonHttpService: CommonHttpService,
    private toastrService: ToastrService,
    private route: ActivatedRoute
  ) { }
  ngOnInit() {
    this.route.queryParamMap.subscribe({
      next: (data: any) => {
        this.planId = data.params.id;
      }
    })
    this.buttonText = this.planId ? 'Edit Plan' : 'Save Plan';
    this.getCurrencies();
    if (this.planId) {
      this.isEdit = true;
      this.getPlanById();
    }
  }
  getCurrencies() {
    this.commonHttpService.getCurrencies().subscribe({
      next: (response: any) => {
        this.loaderView = false;
        this.currenciesList = response.data.rows;
      }
    })
  }
  getPlanById() {
    this.loaderView = true;
    this.commonHttpService.getPlanById(this.planId!).subscribe({
      next: (response: any) => {
        const plan = response.data;
        this.planDetails.patchValue({
          planName: plan.name,
          numWorkspaceOwners: plan.workspaceOwnerLimit,
          numEndUsers: plan.userLimit,
          numItAdmins: plan.adminLimit,
          numOfAssets: plan.assetLimit,
          planFee: plan.price,
          planDuration: plan.tenure,
          currencyId: plan.currencyId,
        });
        this.loaderView = false;
      }
    })
  }
  //validation
  planDetailsHasError(controlName: any) {
    const control = this.planDetails.get(controlName);
    return control?.dirty && control?.errors;
  }
  handleCancel() {
    this.router.navigate([ROUTES.SUBSCRIPTION_PLAN])
  }
  onInputChange(field: string, event: any) {
    this.planDetails.get(planFields[field])?.setValue(event.target.value);
  }
  getDuration(event: any) {
    this.planDetails.controls['planDuration'].setValue(((this.planDurationList.find((tenure: any) => tenure.id === event))?.days)!.toString());
  }
  getCurrency(event: any) {
    this.planDetails.controls['currencyId'].setValue(event);
  }
  handlePlan() {
    if (this.isEdit) {
      this.updatePlan();
    } else {
      this.createPlan();
    }
  }
  updatePlan() {
    const formValue = this.planDetails.getRawValue();
    const payload: IUpdatePlanPayload = {
      "name": formValue.planName!,
      "assetLimit": Number(formValue.numOfAssets!)
    }
    this.loaderView = true;
    this.commonHttpService.updatePlan(this.planId!, payload).subscribe({
      next: (response: any) => {
        this.toastrService.success('Plan Updated Successfully', '', {
          toastClass: 'toaster-wrapper',
        });
        this.loaderView = false;
        this.router.navigate([ROUTES.SUBSCRIPTION_PLAN]);
      },
      error: (err) => {
        const errorList = err.error?.error?.errorList;
        const errorMessage = Array.isArray(errorList)
          ? errorList[0]?.msg || 'Error updating workspace'
          : errorList || 'Error updating workspace';
        this.toastrService.error(errorMessage, '', {
          toastClass: 'toaster-wrapper',
        });
        this.loaderView = false;
      }
    });
  }
  createPlan() {
    const formValue = this.planDetails.getRawValue();
    const payload: ICreatePlanPayload = {
      "name": formValue.planName!,
      "userLimit": Number(formValue.numEndUsers!),
      "assetLimit": Number(formValue.numOfAssets!),
      "adminLimit": Number(formValue.numItAdmins!),
      "workspaceOwnerLimit": Number(formValue.numWorkspaceOwners!),
      "price": Number(formValue.planFee!),
      "tenure": Number(formValue.planDuration!),
      "currencyId": formValue.currencyId!,
    };
    this.loaderView = true;
    this.commonHttpService.createPlan(payload).subscribe({
      next: () => {
        this.toastrService.success('Plan Created Successfully', '', {
          toastClass: 'toaster-wrapper',
        });
        this.loaderView = false;
        this.router.navigate([ROUTES.SUBSCRIPTION_PLAN]);
      },
      error: (err) => {
        const errorList = err.error?.error?.errorList;
        const errorMessage = Array.isArray(errorList)
          ? errorList[0]?.msg || 'Error creating workspace'
          : errorList || 'Error creating workspace';
        this.toastrService.error(errorMessage, '', {
          toastClass: 'toaster-wrapper',
        });
        this.loaderView = false;
      },
    })
  }
}
